const initialState = {
  // true once the initial /api/me check has come back, so the header can
  // show nothing rather than flash "Log in" before we actually know
  checked: false,
  authenticated: false,
  email: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case 'AUTH_STATUS': {
      return Object.assign({}, state, {
        checked: true,
        authenticated: action.payload.authenticated,
        email: action.payload.email,
      });
    }
    default:
      return state;
  }
}
